<template>
	<div class="xingshiListBox">
		<div class="xingshiList" :style="{bottom:bottomShow?'0':'-500px'}" v-show="listShow">
			<div class="top">
				<p :class="{active:checkIndex == 1}" @click="checkIndex = 1;label=label3">服务商</p>
				<p :class="{active:checkIndex == 2}" @click="checkIndex = 2;">星使</p>
				<img class="close" @click="closeFun" src="./img/close.png">
			</div>
			<div class="list">
				<div class="search">
					<input type="text" placeholder="城市筛选" v-model="cityName"/>
					<select v-model="lableType">
						<option value="">类型筛选</option>
						<option v-for="(item,index) in label" :value="item">{{item}}</option>
					</select>
					<input type="text" placeholder="关键字筛选" v-model="keyName"/>
				</div>
				<div class="boxScll">
					<ul class="box" v-if="checkIndex == 1">
						<template v-for="item in countryDetail.citydetails">
							<li @click="detailsFun(fw.id)" v-for="fw in item.institutes" v-show="item.city.cityName.indexOf(cityName) != -1 && fw.name.indexOf(keyName) != -1 && fw.category.indexOf(lableType) != -1">
								<img class="icon" :src="fw.logo">
								<div class="textBox">
									<p class="text1">{{fw.name}}</p>
									<p class="text2">{{fw.des ? fw.des :'暂无'}}</p>
								</div>
								<p class="text text3" :style="{visibility:judgeId(fw.id)?'auto':'hidden'}">参与救援中</p>
								<p class="text marginLeft">{{item.city.stateName || '城市未填写'}}</p>
								<p class="text marginLeft">{{fw.category}}</p>
								<img class="zhankai" src="./img/jiantou.png">
							</li>								
						</template>
					
					</ul>
					<ul class="box" v-if="checkIndex == 2" >
						<template v-for="item in countryDetail.citydetails">
						<li @click="detailsFun1(xs.basic.id,item.city.cityName)" v-for="xs in item.providers"  v-show="item.city.cityName.indexOf(cityName) != -1 && xs.basic.realName.indexOf(keyName) != -1 && lableFun(xs.product.country,xs.product.typeId).indexOf(lableType) != -1" v-if="xs.basic.realName && lableFun(xs.product.country,xs.product.typeId) && item.city.cityName">
							<img class="icon icon2" :src="xs.basic.portrait">
							<div class="textBox textBox1">
								<p class="text1">{{xs.basic.realName}} <span>V已认证</span></p>
								<p class="text2">
									<span>{{xs.uinfo.birthday || '保密'}}</span>
									<span>{{xs.basic.gender == 1 ? '男' : '女'}}</span>
									<span>{{lableFun(xs.product.country,xs.product.typeId)}}</span>
								</p>
							</div>
							<p class="text text3" :style="{visibility:judgeId1(xs.id)?'auto':'hidden'}">参与救援中</p>
							<p class="text marginLeft" v-if="item.city != undefined">{{item.city.stateName || '城市未填写'}}</p>
							<p class="text marginLeft" v-else>城市未填写</p>
							<p class="text marginLeft">{{lableFun(xs.product.country,xs.product.typeId)}}</p>
							<img class="zhankai" src="./img/jiantou.png">
						</li>
						<li @click="detailsFun1(xs.basic.id,item.city.cityName)" v-for="xs in item.providers" v-else>
							<img class="icon icon2" :src="xs.basic.portrait">
							<div class="textBox textBox1">
								<p class="text1">{{xs.basic.realName}} <span>V已认证</span></p>
								<p class="text2">
									<span>{{xs.uinfo.birthday || '保密'}}</span>
									<span>{{xs.basic.gender == 1 ? '男' : '女'}}</span>
									<span>{{lableFun(xs.product.country,xs.product.typeId)}}</span>
								</p>
							</div>
							<p class="text text3" :style="{visibility:judgeId1(xs.id)?'auto':'hidden'}">参与救援中</p>
							<p class="text marginLeft" v-if="item.city != undefined">{{item.city.stateName || '城市未填写'}}</p>
							<p class="text marginLeft" v-else>城市未填写</p>
							<p class="text marginLeft">{{lableFun(xs.product.country,xs.product.typeId)}}</p>
							<img class="zhankai" src="./img/jiantou.png">
						</li>
						</template>
					</ul>
				</div>
<!--				
				<p class="huadong">滑动以加载更多</p>-->
			</div>
		</div>
		<div class="xingshiList">
			<detailsBox v-show='fwsShow' @childClose=childClose ref=detailsBox></detailsBox>
			<detailsXingshi v-show='xsShow' @childClose1=childClose1 ref=detailsXingshi></detailsXingshi>
		</div>
	</div>

</template>

<script>
	import detailsBox from './details'
	import detailsXingshi from './detailsXingshi'
	import moren from './img/logo.jpg'
//	import { getlistCountryCode } from '@/views/axios/api.js';
	export default{
		data(){
			return {
				bottomShow:false,
				checkIndex:1,//服务商星使切换
				fwsShow:false,
				xsShow:false,
				listShow:true,
				label:'',
				label1:['旅游达人','专业律师 ','安保专家'],//国内
				label2:['普通星使','医疗星使','法律星使','旅游星使','公益星使'],//国外
				label3:['救援公司','包机公司','安保公司','律师事务所','旅行社','健康管理公司','体验中心','运动俱乐部（协会）','护理公司','留学机构','移民公司','家政公司','翻译公司','礼宾公司','航空公司','车辆租赁','养老机构','汽车俱乐部','房屋租赁','快递公司','医疗机构','急救中心','公证机构'],
				cityName:'',
				keyName:'',
				lableType:'',
			}
		},
		components:{
			detailsBox,
			detailsXingshi
		},
		props:[
			'countryDetail',
			'countryCode',
			'countryCodeXs'
		],
		
		mounted(){
			this.label=this.label3;
		},
		methods:{
			closeFun(){
				this.$emit('listBox')
			},
			animatFun(status){
				this.bottomShow=status;
			},
			detailsFun(id){//服务商
				this.listShow=false;
				this.fwsShow=true;
				this.$refs.detailsBox.getInstituteDetail(id)
			},
			detailsFun1(id,city){//星使
				this.listShow=false;
				this.xsShow=true;
				this.$refs.detailsXingshi.getInstituteDetail(id,city)
			},
			childClose(){//服务商
				this.listShow=true;
				this.fwsShow=false;
			},
			childClose1(){//星使
				this.listShow=true;
				this.xsShow=false;
			},
			lableFun(num,type){
				var typeName=''
				if(this.checkIndex == 2){
					if(type){
						if(num == '+86'){
							typeName = this.label1[type];
							this.label=this.label1;
						}else{
							typeName = this.label2[type];
							this.label=this.label2;						
						}					
					}else{
						typeName='暂无标签'
					}					
				}else{
					this.label=this.label3;
				}
				return typeName
			},
			judgeId(id){
        console.log(this.countryCode,'this.countryCodethis.countryCode')
        var that = this;
				var status=false
				that.countryCode.forEach(item =>{
					if(id == item.id){
						status=true
					}
				})
				return status				
			},
			judgeId1(id){
				var status=false
				this.countryCodeXs.forEach(item =>{
					if(id == item.id){
						status=true
					}
				})
				return status				
			},
		}
	}
</script>

<style scoped="scoped">
	* {box-sizing: border-box;}
	.xingshiListBox{height: 100%;width: 100%;background-color: rgba(0,0,0,0.3);overflow: hidden;}
	.xingshiList{background-color: white;position: absolute;left: 0;bottom: 0px;width: 100%;transition:all 0.3s}
	.xingshiList .top{text-align: center;line-height: 50px;border-bottom: 1px solid #eee;font-size: 20px;cursor: pointer;position: relative;-webkit-tap-highlight-color: rgba(0, 0, 0, 0);}
	.xingshiList .top p{display: inline-block;padding: 0 10px;outline: none;}
	.xingshiList .top p:nth-child(2){margin-left: 100px;}
	.xingshiList .active{color: #00abf9;border-bottom: 2px solid #00abf9;margin-bottom: -1px;}
	.xingshiList .close{position: absolute; top:22px;right: 30px;}
	.xingshiList .list{padding-top: 10px}
	.xingshiList .list .search{overflow: hidden;padding: 0 50px;}
	.xingshiList .list .search input{display:inline-block;width: 29%;margin-right: 5%;border: 1px solid #eee;padding: 10px 10px;font-size: 16px;border-radius: 5px;background: url(./img/serch.png) no-repeat 95% center;background-size: 20px;font-size: 14px;outline: none;}
	.xingshiList .list .search select{display:inline-block;width: 29%;margin-right: 5%;border: 1px solid #eee;padding: 8px 10px;font-size: 16px;border-radius: 5px; outline: none;}
	.xingshiList .list .search input:last-child{margin-right: 0;}
	.xingshiList .box{margin-top: 20px;}
	.xingshiList .box li{padding: 10px 0;border-bottom: 1px solid #eee;overflow: hidden;cursor: pointer;}
	.xingshiList .box li .icon{float: left; width: 110px;height: 60px;}
	.xingshiList .box li .textBox{float: left;margin-left: 20px;padding: 5px 0;width: 300px;}
	.xingshiList .box li .textBox p{line-height: 30px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
	.xingshiList .box li .textBox p.text2{font-size: 14px;color: #666;}
	.xingshiList .box li .text{float: left;line-height: 60px;}
	.xingshiList .box li .text3{color: #ffc345;position: relative;padding-left: 20px;margin-left: 20px;}
	.xingshiList .box li .text3:before{content: '';display: block;width: 15px;height: 15px;border-radius: 50%;background: #ffc345;position: absolute;top: 33px; left: 0;}
	.xingshiList .box li .zhankai{float: right;margin-top: 30px;}
	.boxScll{height: 285px;overflow-y: auto;padding: 0 50px;}
	.huadong{text-align: center;line-height: 30px;margin-top: 20px;color: #666;}
	.xingshiList .box li .icon2{height: 80px;width: 80px;border-radius: 50%;}
	.xingshiList .box li .textBox1 .text1 span{color: #ff7800;padding-left: 10px;}
	.xingshiList .box li .textBox1 .text2 span{padding-right: 10px;line-height: 16px;}
	.xingshiList .box li .textBox1 .text2 span:nth-child(2){border-right: 1px solid #ccc;padding: 0 10px;border-left: 1px solid #ccc;margin-right: 10px;}
	.marginLeft {margin-left: calc((100% - 860px)/2);width: 150px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
</style>


// WEBPACK FOOTER //
// src/views/map/list.vue